import React, {Component} from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom';
import {Buffer} from 'buffer';
import {connect} from 'react-redux';
import LinesEllipsis from 'react-lines-ellipsis';

import {isLogin, logout} from '../../utils';
import Menu from './Menu';
import {getCompareCount} from '../../utils/byoscart';
import store, {CART_COUNT_UPDATE, COMPARE_COUNT_UPDATE} from '../../utils/store';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: [],
            searchTrending: [],
            searchProducts: [],
            searchText: '',
            searchBoxOpen: false,
            serviceCheck: false,
            isScrolled: false,
            desktopMainHeight: 0,
            desktopNavHeight: 0,
            desktopHeaderHeight: 0,
        };

        this.handleLogout = this.handleLogout.bind(this);
        this.searchBoxHover = false;
        this.handleWindowScroll = this.handleWindowScroll.bind(this);
        this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
        this.mainHeaderRef = React.createRef();
        this.navHeaderRef = React.createRef();
    }

    async componentDidMount() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));

        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/menu', params);
            const resVal = response.data;
            if (resVal.status === 'success') {
                this.setState({menu: resVal.data});
                store.dispatch({type: CART_COUNT_UPDATE, value: resVal.cartCount});
            }
        } catch (error) {
            console.error(error);
        }

        setTimeout(() => {
            store.dispatch({type: COMPARE_COUNT_UPDATE, value: getCompareCount()});
        }, 200);

        this.loadSearch();
        this.updateHeaderHeight();
        window.addEventListener('scroll', this.handleWindowScroll, {passive: true});
        window.addEventListener('resize', this.updateHeaderHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll);
        window.removeEventListener('resize', this.updateHeaderHeight);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isScrolled !== this.state.isScrolled) {
            window.requestAnimationFrame(this.updateHeaderHeight);
        }
    }

    handleWindowScroll() {
        const isScrolled = window.scrollY > 10;
        if (this.state.isScrolled !== isScrolled) {
            this.setState({isScrolled});
        }
    }

    updateHeaderHeight() {
        if (window.innerWidth <= 991) {
            if (this.state.desktopHeaderHeight !== 0 || this.state.desktopMainHeight !== 0 || this.state.desktopNavHeight !== 0) {
                this.setState({
                    desktopHeaderHeight: 0,
                    desktopMainHeight: 0,
                    desktopNavHeight: 0,
                    isScrolled: false,
                });
            }
            return;
        }

        const mainHeight = this.mainHeaderRef.current ? this.mainHeaderRef.current.offsetHeight : 0;
        const navHeight = this.navHeaderRef.current ? this.navHeaderRef.current.offsetHeight : 0;
        const desktopHeaderHeight = mainHeight + navHeight;

        if (
            this.state.desktopHeaderHeight !== desktopHeaderHeight ||
            this.state.desktopMainHeight !== mainHeight ||
            this.state.desktopNavHeight !== navHeight
        ) {
            this.setState({
                desktopHeaderHeight,
                desktopMainHeight: mainHeight,
                desktopNavHeight: navHeight,
            });
        }
    }

    async loadSearch() {
        const params = new URLSearchParams();
        params.append('search_text', this.state.searchText);

        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/search', params);
            const resVal = response.data;
            if (resVal.status === 'success') {
                this.setState({
                    searchTrending: Array.isArray(resVal.searchTrending) ? resVal.searchTrending : [],
                    searchProducts: Array.isArray(resVal.searchProducts) ? resVal.searchProducts : [],
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    getSearchResult(searchText) {
        this.setState({searchText, searchBoxOpen: true});
        setTimeout(() => {
            this.loadSearch();
        }, 200);
    }

    openSearchBox() {
        this.setState({searchBoxOpen: true});
    }

    closeSearchBox() {
        setTimeout(() => {
            if (this.searchBoxHover !== true) {
                this.setState({searchBoxOpen: false});
            }
        }, 150);
    }

    handleLogout() {
        logout();
        this.props.history.push('/');
    }

    render() {
        const searchTrending = Array.isArray(this.state.searchTrending) ? this.state.searchTrending : [];
        const searchProducts = Array.isArray(this.state.searchProducts) ? this.state.searchProducts : [];
        const profileName = (localStorage.getItem('BYOS_UserName') || '').trim();
        const showVideoBanner = this.props.location && this.props.location.pathname === '/';
        const desktopHeaderClassName = `ps-header ps-header--1 ${this.state.isScrolled ? 'ps-header--scrolled' : ''}`;
        const desktopHeaderStyle = this.state.desktopMainHeight
            ? {'--ps-header-main-height': `${this.state.desktopMainHeight}px`}
            : undefined;

        return (
            <div>
                <header className={desktopHeaderClassName} style={desktopHeaderStyle}>
                    <div className="ps-header__promo" role="status" aria-label="Offers and important news">
                        <div className="container">
                            <div className="ps-header__promoItem">
                                <i className="fa fa-tag" aria-hidden="true"></i>
                                <span>Special offers available now</span>
                                <Link to="/" className="ps-header__promoMore">View More</Link>
                            </div>
                        </div>
                    </div>
                    <div className="ps-header__main" ref={this.mainHeaderRef}>
                        <div className="container">
                            <div className="ps-header__mainRow">
                                <div className="ps-header__brand">
                                    <Link to="/" className="ps-header__brandLink" aria-label="Home">
                                        <img src="/assets/img/logo.png" alt="Nature Way" className="ps-header__brandLogo" />
                                    </Link>
                                </div>

                                <div className="ps-header__navSlot">
                                    <Menu menu={this.state.menu} />
                                </div>

                                <div className="ps-header__actions">
                                    {isLogin() ? (
                                        <div className="ps-header__account dropdown">
                                            <div
                                                className="ps-header__accountToggle dropdown-toggle"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <i className="icon-user"></i>
                                                <span>{profileName !== '' ? profileName : 'Profile'}</span>
                                            </div>
                                            <div className="dropdown-menu accountDropdownMenu" aria-labelledby="dropdownMenuButton">
                                                <Link to="/account" className="ps-header__item_child">My Profile</Link>
                                                <Link to="/orders" className="ps-header__item_child">Orders</Link>
                                                <Link to="/wishlist" className="ps-header__item_child">Wishlist</Link>
                                                <span onClick={() => this.handleLogout()} className="ps-header__item_child">Logout</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <Link className="ps-header__actionLink" to="/signin">
                                            <i className="icon-user"></i>
                                            <span>Login / Sign Up</span>
                                        </Link>
                                    )}

                                    <Link className="ps-header__actionLink" to="/wishlist">
                                        <i className="fa fa-heart-o"></i>
                                        <span>Wishlist</span>
                                    </Link>

                                    {isLogin() ? (
                                        <Link className="ps-header__actionLink ps-header__actionLink--cart" to="/cart" id="cart-mini">
                                            <i className="icon-cart-empty"></i>
                                            <span>Cart</span>
                                            <span className="badge">{this.props.count}</span>
                                        </Link>
                                    ) : (
                                        <Link className="ps-header__actionLink ps-header__actionLink--cart" to="/signin" id="cart-mini">
                                            <i className="icon-cart-empty"></i>
                                            <span>Cart</span>
                                            <span className="badge">0</span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </header>

                <header className="ps-header ps-header--1 ps-header--mobile">
                    <div className="ps-header__middle">
                        <div className="container">
                            <div className="ps-logo">
                                <Link to="/">
                                    <img src="/assets/img/logo.png" alt="Nature Way" />
                                </Link>
                            </div>
                            <div className="ps-header__right">
                                <ul className="ps-header__icons">
                                    <li>
                                        <Link className="ps-header__item open-search" to="/">
                                            <i className="fa fa-search"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </header>

                {showVideoBanner ? (
                    <div className="ps-header__video-banner">
                        <div className="ps-header__video-frame">
                            <video
                                className="ps-header__video"
                                src="/assets/img/natural-video.mp4"
                                autoPlay
                                loop
                                muted
                                playsInline
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        count: state.cart.count,
        comparecount: state.compare.count,
    };
};

export default connect(mapStatetoProps, null)(Header);
